import "bootstrap/dist/css/bootstrap.min.css";
import GenericTable from "components/tables/GenericTable";
import React from "react";
import { Card, Col } from "react-bootstrap";

const GNSSMajorFailureCard = ({ innerRef, data }) => {
  return (
    <>
      <Card.Title as="h6" ref={innerRef}>
        Probability of major service failure
      </Card.Title>
      <Card.Body>
        <p className="text-justify">
          The probability of major service failure shall be computed based on
          the events counted during the entire operational phase of ECHO. An
          event takes place when a healthy satellite’s ranging signal error
          (excluding atmospheric and receiver errors) exceeds the broadcast
          range error limit by a given factor. This parameter is presented as a
          per year probability.
        </p>

        <p className="text-justify">
          {" "}
          Number of major service failure (MSF) events
        </p>
        <Col>
          <GenericTable data={data.msfTable} />
          {data.msfTable.length === 0 && (
            <>
              <p className="text-justify">
                There are no MSF events in the reporting period.
              </p>
              <p className="text-justify">
                The probability of MSF per year is: TBD
              </p>
            </>
          )}
        </Col>
      </Card.Body>
    </>
  );
};

export default React.memo(
  React.forwardRef((props, ref) => (
    <GNSSMajorFailureCard innerRef={ref} {...props} />
  ))
);
